export default __webpack_public_path__ + "static/ibm-c584c6c632798abc8f1caa7b569e9794.png";